import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>
                Key Features of Our Telemedicine App Development Solutions
              </h2>
              <p>
                Through the incorporation of advanced functionality and your use
                of telemedicine apps, we change the health delivery as well as
                the experience of it completely. We utilize modern
                functionalities in our telemedicine app development solutions to
                advance patient care and improve healthcare flow.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Project Now!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Launching a New App</h6>
              <p>
                Our telemedicine app development company enables healthcare
                providers to hold HIPAA-compliant video consultations with
                patients remotely, as the constraints of distance are overcome.
                With improved video and audio equipment, patients can avail of
                the services in real-time from the convenience of their homes,
                missing out on any protocol whatsoever on the regulation of
                health care.
              </p>
            </div>
            <div className="consider-box">
              <h6>Appointment Scheduling and Reminders</h6>
              <p>
                Reorganize appointment scheduling and make it a simple process
                with all the scheduling features built into our telemedicine
                application. Everyone can now book, receive their appointment
                reminders, and manage and keep track of all their appointments
                quickly and smoothly. This simplified technique better engages
                patients and issues a productivity boost to the healthcare
                services.
              </p>
            </div>
            <div className="consider-box">
              <h6>Electronic Health Record (EHR) Integration</h6>
              <p>
                Interlink EHR to our telemedicine application and at the same
                time ensure the healthcare professionals have access to patient
                medical history, treatment plans, and clinical data during the
                virtual consultation. With direct access to the patient’s
                detailed medical record, doctors can deliver personalized health
                care and quality care through all virtual visits.
              </p>
            </div>
            <div className="consider-box">
              <h6> Secure Messaging and File Sharing</h6>
              <p>
                Promote communication and coordination between patients and
                healthcare practitioners via secure messaging and file-sharing
                within the platform. Our telemedicine app developers offer
                encrypted messages and let patients message their providers. It
                fosters engagement, and the connection of effective information
                sharing helps in achieving optimal patient outcomes.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
